module.exports = __webpack_public_path__ + "static/media/default_reflection_image.b539bf0c.svg";